
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"43","height":"33","viewBox":"0 0 43 33","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M41.0413 1.50746C39.3049 -0.318129 36.4821 -0.318129 34.7457 1.50746L15.6316 21.5749L7.64848 13.195C5.91205 11.3694 3.08925 11.3694 1.35282 13.195C-0.385836 15.0205 -0.385836 17.9798 1.35282 19.8054L12.4838 31.4929C13.352 32.4069 14.4918 32.8627 15.6316 32.8627C16.7714 32.8627 17.9112 32.4069 18.7794 31.4929L41.0413 8.1179C42.78 6.29232 42.78 3.33304 41.0413 1.50746Z","fill":"#357D67"}})])
          )
        }
      }
    